import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import _ from 'lodash';
import Link from 'next/link';
import TravelWitsLogo from '../assets/svgs/travelwitsLogo.svg';

const TwThemeProvider = ({ children }) => {
  const { travelAgency, isLoggedIn } = useSelector((store) => store.user);
  const router = useRouter();
  const { nocode } = router.query;
  const doShowNoCodeSidebar = isLoggedIn && !_.isUndefined(nocode) && nocode !== 'false';

  useEffect(() => {
    if (travelAgency && travelAgency.isTravelAgencyBySite && travelAgency.siteTheme) {
      Object.keys(travelAgency.siteTheme).forEach((t) => {
        document.body.style.setProperty(t, travelAgency.siteTheme[t]);
      });
    }
  }, [travelAgency]);

  return !doShowNoCodeSidebar ? <div>{children}</div> : (
    <div className="flex max-h-screen">
      <div className="app-sidebar m-5 mt-10" style={{ width: '345px' }}>
        <div>
          <Link href="/">
            <a className="text-red">
              <TravelWitsLogo fill="black" />
            </a>
          </Link>
        </div>
        <div className="mt-12 text-2xl">
          <a target="_blank" rel="noreferrer" href="https://baserow.io/database/37832/table/90489">
            Data
          </a>
        </div>
      </div>
      <div className="flex-grow max-h-screen overflow-auto">
        <div className="shadow-2xl m-10">
          <div className="bg-gray-200">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

TwThemeProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.any),
    PropTypes.arrayOf(PropTypes.any)]).isRequired,
};

export default TwThemeProvider;
